import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OrderFiles } from 'src/app/shared/models/orders';

/** Visor visual de archivos. No conoce pedidos, perfiles ni servicios de negocio. */
@Component({
  selector: 'app-history-files-viewer',
  templateUrl: './history-files-viewer.component.html',
  styleUrls: ['./history-files-viewer.component.css'],
  standalone: false,
})
export class HistoryFilesViewerComponent implements OnInit {
  @Input() files: OrderFiles[] = [];

  isMobile = false;
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  private dialogRef?: MatDialogRef<any>;

  constructor(
    private readonly dialog: MatDialog,
    private readonly deviceService: DeviceDetectorService,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
  }

  openModal(): void {
    this.dialogRef = this.dialog.open(this.modalContent, {
      maxWidth: '90%',
      scrollStrategy: this.scrollStrategyOptions.noop(),
    });
  }

  closeModal(): void {
    this.dialogRef?.close();
  }

  download(): void {
    if (this.isMobile) {
      this.files.forEach((file) => window.open(file.url, '_blank'));
      return;
    }

    this.files.forEach((file) => {
      fetch(file.url)
        .then((response) => response.blob())
        .then((blob) => saveAs(blob, file.fileName))
        .catch((error) => console.error('Error on download: ', error));
    });
  }
}
